import axiosInstance from "../mainService";

const requirementService = {
    addRequirement(requirement) {
        return axiosInstance.post('/insert-data/m149_requirements', requirement);
    },
    updateRequirement(requirement) {
        return axiosInstance.put(`/update-data/m149_requirements/${requirement.id}`, requirement);
    },
    getAllRequirements( search,page, limit) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/requirement/requirement/${sanitizedSearch}/${page}/${limit}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    getRequirement(search, page, limit, company){
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m149_requirements/requirement/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    getOnlyRequirements(id, company) {
        return axiosInstance.get(`/requirements/${id}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllRequirements(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m149_requirements/requirement/${sanitizedSearch}/${company}`);
    },
    addMappingRequirement(requirement) {
        return axiosInstance.post('/insert-data/t105_career_details', requirement);
    },
    updateStatusCareerDetail(requirement) {
        return axiosInstance.put(`/update-data/t105_career_details/${requirement.id}`, requirement);
    },
    deleteRequirement(id) {
        return axiosInstance.delete(`/delete-data/m149_requirements/${id}`);
    },
};

export default requirementService;